import React, { useState,useEffect } from 'react';
import { useTranslate } from 'react-redux-multilingual'
import {useHistory} from 'react-router-dom'
import {CardPerso} from '@gull'
import axios from 'axios';
import swal from "sweetalert2";
import { Tabs, Tab } from "react-bootstrap";

const BarNumSearchBilling = (props) =>{
    const t = useTranslate();
    const history = useHistory()

    const [valueInput,setValueInput]=useState({
        numero:'',
        bar:'',
        type:'billing',
        company:''
    }) 
    const [campanyName,setCompanyName]=useState(props.company.code) 
    const [validButton,setValidButton]=useState({
        bar:false,
        num:false
    }) 

    useEffect(function () {
        if(valueInput.company==''){
            setCompanyName(props.company.code)
        }else{
            let idCompany = valueInput.company.replace('/','')
            let selected = props.company.other_company.find(value=>value.id==idCompany)

            setCompanyName(selected.code)
        }
    }, [valueInput,valueInput.company,props.company])

    const handleChange = (e,name) =>{
        setValueInput({...valueInput,[name]:e.target.value})
    }

    const submitBilling = async (e,name) =>{
        if(e.target) e.preventDefault()
        let paramMiddle = (name=='bar') ? valueInput.bar : valueInput.numero
        let paramType = (name=='bar') ? '' : '/'+valueInput.type
        let paramCampany = (name=='bar') ? '' : valueInput.company
        let url = (name=='bar') ? 'api/facture/invoice/get_one_by_reference/' : 'api/facture/invoice/get_one_by_number/'
        //si name est égale à num, on recherche par le numéro
        
        setValidButton({...validButton,[name]:true})
        const response = await axios.get(process.env.REACT_APP_API_URL+url+paramMiddle+paramType+paramCampany
        ).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach(interm=>messageError+=t(interm)+'. ')
                messageError=messageError.replace('undefined','');
                swal.fire(messageError, "", "error");
            }
            else{   
                history.push("/invoice/details/"+response.data.data.id)
            }
        }).catch((error) => {
            if(error=='end_session') return;
            let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
            swal.fire(t(errorName), "", "error");
        })
        setValidButton({...validButton,[name]:false})
    }

    let prefixe={
        creditNote:'AVO',
        purchaseOrderB2b:'BCO',
        deliveryNote:'BDL',
        returnNote:'BRE',
        quotation:'DEV',
        billing:'FAC',
        billingBuy:'BUY',
        billingDeposit:'ACO'
    }

    return (
        <CardPerso header={t('searchBy')+' '+t('number').toLowerCase()+' '+t('or').toLowerCase()+' '+t('tableBarCode').toLowerCase()}>
            <div className='mt-2'>
                <Tabs defaultActiveKey="numero" id="uncontrolled-tab-example">
                    <Tab eventKey="numero" title={t('searchBy')+' '+t('number').toLowerCase()} >
                        <div className='col-12 form-group'>
                            <select className='form-control' value={valueInput.company} onChange={(e)=>handleChange(e,'company')}>
                                <option value={''}>{props.company.name}</option>                            
                                {Object.keys(props.company).length !=0 && props.company.other_company.length != 0 &&
                                    props.company.other_company.map(value=>{
                                        return(
                                            <option key={value.id} value={'/'+value.id}>{value.name}</option>
                                        )
                                    })
                                }
                            </select>
                        </div>
                        <div className='col-12 form-group'>
                            <select className='form-control' value={valueInput.type} onChange={(e)=>handleChange(e,'type')}>
                                <option value="creditNote">{t('creditNote')}</option>
                                <option value="purchaseOrderB2b">{t('purchaseOrderB2b')}</option>
                                <option value="deliveryNote">{t('deliveryNote')}</option>
                                <option value="returnNote">{t('returnNote')}</option>
                                <option value="quotation">{t('quotation')}</option>
                                <option value="billing">{t('billing')}</option>
                                <option value="billingBuy">{t('billingBuy')}</option>
                                <option value="billingDeposit">{t('billingDeposit')}</option>
                            </select>
                        </div>

                        <div className="col-12">
                            <div className="form-group">
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text" id="basic-addon1">{prefixe[valueInput.type]+campanyName+' (Date)-'}</span>
                                    </div>
                                    <input value={valueInput.numero} type="text" className="form-control" onChange={(e)=>handleChange(e,'numero')} placeholder={t('docNum')+'...'} />
                                </div>
                            </div>
                        </div>

                        <div className="col mt-2">
                            <button disabled={valueInput.numero=='' || validButton.num} className='btn btn-primary' onClick={()=>submitBilling(false,'num')}>{validButton.num ? <span><span>&nbsp;</span><div className="spinner-border spinner-border-sm"></div></span> : t('btnValidate')}</button>
                        </div>
                    </Tab>
                    <Tab eventKey="bar" title={t('searchBy')+' '+t('tableBarCode').toLowerCase()}>
                        <div className='row'>
                            <div className="col-12">
                                <form onSubmit={(e)=>submitBilling(e,'bar')}>
                                    <div className="form-group">
                                        <input defaultValue={valueInput.bar} type="text" className="form-control" onChange={(e)=>handleChange(e,'bar')} placeholder={t('scanDocHere')+'...'}/>
                                    </div>
                                    <div className="col mt-2">
                                        <button disabled={valueInput.bar=='' || validButton.bar} className='btn btn-primary' onClick={()=>submitBilling(false,'bar')}>{validButton.bar ? <span><span>&nbsp;</span><div className="spinner-border spinner-border-sm"></div></span> : t('btnValidate')}</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </Tab>
                </Tabs>
            </div>
        </CardPerso>
    )
};

export default BarNumSearchBilling;